
import * as route from "./route";
import * as module from "./module";

export default {
  modulename: 'syncMap', route, module
}